__turbopack_context__.v({
  "add": "ayLhAG_add",
  "description": "ayLhAG_description",
  "error": "ayLhAG_error",
  "label": "ayLhAG_label",
  "list": "ayLhAG_list",
  "makePrimary": "ayLhAG_makePrimary",
  "primaryBadge": "ayLhAG_primaryBadge",
  "remove": "ayLhAG_remove",
  "root": "ayLhAG_root",
  "rowActions": "ayLhAG_rowActions",
});
